
import image1 from '../assets/projects/image-1.jpg'
import image2 from '../assets/projects/image-2.jpg'
import image3 from '../assets/projects/image-3.jpg'

export const data=[
    {
        id:1,
        name:"Loops Studios",
        image:image1,
        github:"https://github.com/JhainBolar/Loop-Studios",
        live:"https://fabulous-peony-61c221.netlify.app",
    },
    {
        id:2,
        name:"Tip Calculator",
        image:image2,
        github:"https://github.com/JhainBolar/Tip-Calculator",
        live:"https://jocular-sprinkles-978439.netlify.app",
    },
    {
        id:3,
        name:"Social Media",
        image:image3,
        github:"https://github.com/JhainBolar/SocialMedia-NEw",
        live:"https://tranquil-starship-e494b8.netlify.app",
    }

]